import { Mandant } from '../../../../projects/kiene-core/src/lib/components/mandanten/classes/mandant';

export class SelectMandantDialogInput {
    title = 'Bitte Mandanten auswählen';
    mandanten: Mandant[] = [];

    constructor(mandanten: Mandant[], options?: { title: string }) {
        this.mandanten = mandanten;
        if (options?.title) {
            this.title = options.title;
        }
    }
}
